import { GROWLER__HIDE, GROWLER__SHOW, GROWLER__ABORT } from './constants';

export function hideGrowler() {
  return {
    type: GROWLER__HIDE,
  };
}

export function showGrowler(text, notificationType, timeout) {
  return {
    type: GROWLER__SHOW,
    text,
    notificationType,
    timeout,
  };
}

export function showGrowlerSuccess(text) {
  return {
    type: GROWLER__SHOW,
    text,
    notificationType: 'growler--success',
  };
}

export function showGrowlerError(text) {
  return {
    type: GROWLER__SHOW,
    text,
    notificationType: 'growler--error',
  };
}

export function showGrowlerAbort(text) {
  return {
    type: GROWLER__ABORT,
    text,
    notificationType: 'growler--error',
  };
}



// WEBPACK FOOTER //
// ./src/containers/Notification/actions.js